import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../../services/admin.service';
import { Response } from '@angular/http';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user.model';
import { Group } from '../../../models/group.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddMemberPopupComponent } from './popups/add-member-popup/add-member-popup.component';
import { SetHeadDeputyComponent } from './popups/set-head-deputy/set-head-deputy.component';
import { ConfirmationPopupComponent } from './popups/confirmation-popup/confirmation-popup.component';
import { ReportDatepickerComponent } from '../../../modals/report-datepicker.component';
import { ReportType } from '../../../models/report-type.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';
import { ChangeUserPositionComponent } from './popups/change-user-position/change-user-position.component';
import { InfoPopupComponent } from './popups/info-popup/info-popup.component';
import { RenamePositionComponent } from './popups/rename-position/rename-position.component';
import { ChangeUserPasswordComponent } from './popups/change-user-password/change-user-password.component';
import { AlertShowComponent } from '../../common/alert-show/alert-show.component';
import { ChangeKarmaDescriptionComponent } from '../view-group/change-karma-description/change-karma-description.component';
import { VectorValueComponent } from '../view-group/vector-value/vector-value.component';
import { GROUP_CONSTANTS, DEFAULT_VALUES, TIMEOUT_VALUES, HTTP_STATUS_CODES } from '../../../shared.constants/all-constants';

interface SortCriterion {
	userOrder: string;
	order: string;
}

@Component({
	selector: 'app-view-group',
	templateUrl: './view-group.component.html',
	styleUrls: ['./view-group.component.css']
})
export class ViewGroupComponent implements OnInit {
	canDeleteActive = 0;
	canDeleteInactive = 0;

	isUserSelected = false;
	isPosSelected = false;

	user: User;
	isAdmin = false;
	isHeadOfGroup = false;
	isUser = false;
	isHead = false;
	isDeputy = false;
	popoverIsHidden = true;
	suc = false;
	group: Group;
	isLoaded = false;
	errorInfo = false;
	dataListVector = [];
	mainGroup;
	groupPositions: any[] = [];
	groupType = '';
	karmaList = [];
	activeUser;
	groups = [];
	mobWidth: any;
	nodata = false;
	id;
	rep = false;
	currentMounth;
	skillsSelected = false;
	loyaltySelected = false;
	gravitySelected = false;
	integrationSelected = false;
	speedSelected = false;
	vectorOrders: string[] = [];
	usersListWithVectors;
	sortOrder: any = {};
	sortByNativeName: boolean = false;

	sortCriteria: SortCriterion[] = [{ userOrder: GROUP_CONSTANTS.SORT_BY_LAST_NAME, order: GROUP_CONSTANTS.SORT_DESC }];

	sortState = {
		[GROUP_CONSTANTS.SORT_BY_SKILLS]: DEFAULT_VALUES.NULL_VALUE,
		[GROUP_CONSTANTS.SORT_BY_LOYALTY]: DEFAULT_VALUES.NULL_VALUE,
		[GROUP_CONSTANTS.SORT_BY_GRAVITY]: DEFAULT_VALUES.NULL_VALUE,
		[GROUP_CONSTANTS.SORT_BY_INTEGRATION]: DEFAULT_VALUES.NULL_VALUE,
		[GROUP_CONSTANTS.SORT_BY_SPEED]: DEFAULT_VALUES.NULL_VALUE,
		[GROUP_CONSTANTS.SORT_BY_LAST_NAME]: GROUP_CONSTANTS.SORT_ASC,
		[GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME]: DEFAULT_VALUES.NULL_VALUE
	};

	constructor(private userService: UserService,
		private route: ActivatedRoute,
		private adminService: AdminService,
		private modalService: NgbModal,
		private formatService: TimeFormatterService,
		private cdr: ChangeDetectorRef) {
		if (this.route.snapshot.params['rep']) {
			this.rep = true;
		} else {
			this.rep = false;
		}
		this.id = JSON.parse(localStorage.getItem('User')).id;

		this.mobWidth = window.innerWidth;

		const getWindow = () => {
			return window.innerWidth;
		};

		window.onresize = () => {
			this.mobWidth = getWindow();
			this.cdr.detectChanges();
		};
	}

	ngOnInit() {
		this.currentMounth = new Date().getMonth() + 1;
		this.user = this.userService.getLocal();
		this.isAdmin = false;
		this.isHead = false;
		this.isUser = false;
		if (this.user.roles.indexOf(GROUP_CONSTANTS.ROLE_ADMIN) !== -1) {
			this.isAdmin = true;
		}
		if (this.user.roles.indexOf(GROUP_CONSTANTS.ROLE_HEAD) !== -1) {
			this.isHead = true;
		}
		if (this.user.roles.indexOf(GROUP_CONSTANTS.ROLE_USER) !== -1) {
			this.isUser = true;
		}
		this.getList(this.route.snapshot.params['id']);
		if (this.isHead && this.isAdmin) {
			this.getAllGroupForList();
		} else if (this.isHead && !this.isAdmin && !this.rep) {
			this.getAllGroups();
		} else if (this.isHead && !this.isAdmin && this.rep) {
			this.getAllGroupForList();
		}
	}

	getTitle(record: any, from = ''): string {
		const workStart = record.workStart || DEFAULT_VALUES.NA_STRING;
		const workEnd = record.workEnd || DEFAULT_VALUES.NA_STRING;
		const segmentsData = record.segments.map((segment: any) => `Work: ${segment.workDays} / Rest: ${segment.restDays}`).join(' | ');
		if (from != '') {
			return `Start of the scheduler: ${from} Start work: ${workStart} - End work: ${workEnd}  Period: ${segmentsData}`;
		} else {
			return `Start work: ${workStart} - End work: ${workEnd}  Period: ${segmentsData}`;
		}
	}

	hasOtherShifts(): boolean {
		const schedule = this.activeUser.user.schedule.schedule.id;
		const group: any = this.group;
		return schedule == group.workScheduleId2.id ||
			schedule == group.workScheduleId3.id ||
			group.flexibleWorkSchedule.some(shift => shift.id == schedule);
	}

	getAllGroups() {
		this.adminService.getGroupsAndPositionsHead().subscribe(
			(res: any) => {
				if (res.status === HTTP_STATUS_CODES.OK) {
					let arr = res.body;
					this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
					let mainGroupId = JSON.parse(localStorage.getItem('User')).mainGroup;
					const relatedId = arr.findIndex(({ id }) => id === mainGroupId);
					const [related] = arr.splice(relatedId, 1);
					this.groups = arr;
					this.groups.unshift(related);
				}
			}
		)
	}

	getAllGroupForList() {
		this.adminService.getAllGroups().subscribe(
			(response: any) => {
				let arr = response.body;
				this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
				let mainGroupId = JSON.parse(localStorage.getItem('User')).mainGroup;
				const relatedId = arr.findIndex(({ id }) => id === mainGroupId);
				const [related] = arr.splice(relatedId, 1);
				this.groups = arr;
				this.groups.unshift(related);
			},
		);
	}

	getUsersByIdGroup(groupId: number) {
		this.getList(groupId)
	}

	getList(groupId: number) {
		this.adminService.getGroupByID(groupId).subscribe(
			(response: any) => {
				if (response.status === HTTP_STATUS_CODES.OK) {
					this.group = response.body;
					this.isLoaded = true;
					this.errorInfo = false;
					this.groupType = response.body.groupType;
					this.checkIfCurrentUserIsHeadOfGroup();
					this.processGroupDeputyAndPositions();

					this.group.positions.forEach(item => {
						item.isPosSelected = false;
					});
				}
				this.getUserListWithVectors();
			},
			() => {
				this.isLoaded = true;
				this.errorInfo = true;
			},
		);
	}

	private processGroupDeputyAndPositions() {
		if (this.group.deputy != DEFAULT_VALUES.NULL_VALUE) {
			if (this.group.deputy.id === this.user.id) {
				this.isDeputy = true;
			}
		}
		this.group.inactiveUsers.forEach(item => {
			let positionExists = false;
			this.groupPositions.forEach(position => {
				if (position.name === item.position.name) {
					positionExists = true;
				}
			});
			if (!positionExists) {
				this.groupPositions.push(item.position);
			}
		});
	}

	private checkIfCurrentUserIsHeadOfGroup() {
		if (this.group.head != DEFAULT_VALUES.NULL_VALUE) {
			if (this.group.head.id === this.user.id) {
				this.isHeadOfGroup = true;
			} else {
				this.isHeadOfGroup = false;
			}
		}
	}

	onCheckboxChange(userOrder: string, order: string) {
		if (this.sortState[userOrder] === order) {
			this.removeSort(userOrder);
			return;
		}
		if (this.sortByNativeName) {
			this.sortByNativeName = false;
			this.sortState[GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME] = DEFAULT_VALUES.NULL_VALUE;
		}
		this.sortState[userOrder] = order;
		const existingCriterionIndex = this.sortCriteria.findIndex(criterion => criterion.userOrder === userOrder);
		if (existingCriterionIndex > -1) {
			this.sortCriteria[existingCriterionIndex].order = order;
		} else {
			this.sortCriteria.push({ userOrder, order });
		}
		this.sortCriteria = this.sortCriteria.filter(criterion => criterion.userOrder !== GROUP_CONSTANTS.SORT_BY_LAST_NAME);
		this.getUserListWithVectors();
	}

	hasActiveSort(): boolean {
		return Object.entries(this.sortState).some(([key, value]) =>
			value !== DEFAULT_VALUES.NULL_VALUE && key !== GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME && key !== GROUP_CONSTANTS.SORT_BY_LAST_NAME
		);
	}

	clearSort() {
		for (const key in this.sortState) {
			if (this.sortState.hasOwnProperty(key)) {
				this.sortState[key] = DEFAULT_VALUES.NULL_VALUE;
			}
		}
		this.sortState[GROUP_CONSTANTS.SORT_BY_LAST_NAME] = DEFAULT_VALUES.NULL_VALUE;
		this.sortCriteria = [{ userOrder: GROUP_CONSTANTS.SORT_BY_LAST_NAME, order: GROUP_CONSTANTS.SORT_DESC }];
		this.getUserListWithVectors();
	}

	getSortIndex(userOrder: string): number {
		return this.sortCriteria.findIndex(criterion => criterion.userOrder === userOrder) + 1;
	}

	removeSort(userOrder: string) {
		this.sortCriteria = this.sortCriteria.filter(criterion => criterion.userOrder !== userOrder);
		this.sortState[userOrder] = DEFAULT_VALUES.NULL_VALUE;
		if (this.sortCriteria.length === 0) {
			this.sortState[GROUP_CONSTANTS.SORT_BY_LAST_NAME] = DEFAULT_VALUES.NULL_VALUE;
			this.sortCriteria.push({ userOrder: GROUP_CONSTANTS.SORT_BY_LAST_NAME, order: GROUP_CONSTANTS.SORT_DESC });
		}
		this.getUserListWithVectors();
	}

	getUserListWithVectors() {
		const apiCall = this.isAdmin ?
			this.adminService.getListVectors(this.group.id, this.sortCriteria) :
			this.adminService.getListVectorsNoSalary(this.group.id, this.sortCriteria);
		apiCall.subscribe(
			(response: any) => {
				this.usersListWithVectors = response.body.users;
			},
			(error) => {
				console.error(error);
			}
		);
	}

	toggleSortByName(): void {
		this.sortByNativeName = !this.sortByNativeName;

		if (this.sortByNativeName) {
			Object.keys(this.sortState).forEach(key => {
				if (key !== GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME && key !== GROUP_CONSTANTS.SORT_BY_LAST_NAME) {
					this.sortState[key] = DEFAULT_VALUES.NULL_VALUE;
				}
			});
			this.sortState[GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME] = GROUP_CONSTANTS.SORT_ASC;
			this.sortState[GROUP_CONSTANTS.SORT_BY_LAST_NAME] = DEFAULT_VALUES.NULL_VALUE;

			this.sortCriteria = [{ userOrder: GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME, order: GROUP_CONSTANTS.SORT_ASC }];
		} else {
			this.sortState[GROUP_CONSTANTS.SORT_BY_FULL_NATIVE_NAME] = DEFAULT_VALUES.NULL_VALUE;
			this.sortState[GROUP_CONSTANTS.SORT_BY_LAST_NAME] = GROUP_CONSTANTS.SORT_ASC;

			this.sortCriteria = [{ userOrder: GROUP_CONSTANTS.SORT_BY_LAST_NAME, order: GROUP_CONSTANTS.SORT_ASC }];
		}
		this.getUserListWithVectors();
	}

	getCurrentLast(userId: number) {
		this.adminService.getLastVector(userId).subscribe(
			(response: any) => {
				const vectorData = response.body;
				let vector = {
					vector: vectorData
				};
				this.group.activeUsers.forEach(item => {
					if (item.user.id.toString() === userId.toString()) {
						Object.assign(item.user, vector);
					}
				});
			},
			(error) => {

			},

		);
	}

	openNewVectorModal(activeUser: any): void {
		const modalRef = this.modalService.open(VectorValueComponent);
		modalRef.componentInstance.action(activeUser);
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.getList(this.route.snapshot.params['id']);
			}
		});
	}

	openReportDatepickerUser() {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_USER;
		modalRef.componentInstance.userId = this.userService.getLocal().id;
	}

	openNewActionModal(action: string, activeUserId: number) {
		const modalRef = this.modalService.open(ChangeKarmaDescriptionComponent);
		modalRef.componentInstance.action(action, activeUserId);
	}

	openNewActionModaltt(action: string, activeUserId: number) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_KARMA;
		modalRef.componentInstance.actionTWO(action, activeUserId);
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.suc = true;
				setTimeout(() => this.suc = false, TIMEOUT_VALUES.DEFAULT_DELAY);
			}
		});
	}

	openNewActionModalReport(userId: number) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_DAY_OFF;
		modalRef.componentInstance.userId = userId;
		modalRef.componentInstance.rep = DEFAULT_VALUES.NOREP_FLAG;
		modalRef.componentInstance.action(GROUP_CONSTANTS.CHOOSE_DAYS_OFF);
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.suc = true;
				setTimeout(() => this.suc = false, TIMEOUT_VALUES.DEFAULT_DELAY);
			}
		});
	}

	openNewActionModalReportShift(userId: number): void {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.SHIFT;
		modalRef.componentInstance.userId = userId;
		modalRef.componentInstance.group = this.group;
		modalRef.componentInstance.action(GROUP_CONSTANTS.SHIFT_WINDOW);

		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.getList(this.route.snapshot.params['id']);

				setTimeout(() => {
					if (this.isHead && this.isAdmin) {
						this.getAllGroupForList();
					}
					this.suc = true;
					setTimeout(() => this.suc = false, TIMEOUT_VALUES.DEFAULT_DELAY);
				}, 100);
			}
		});
	}

	changeUserPassword(passUser: any, ttip: any) {
		ttip.close();
		const modalRef = this.modalService.open(ChangeUserPasswordComponent);
		modalRef.componentInstance.setUserPass(passUser);
	}

	renamePosition(pos: any) {
		const modalRef = this.modalService.open(RenamePositionComponent);
		modalRef.componentInstance.setPositionForRename(pos);
		modalRef.componentInstance.setGroup(this.group);
	}

	setSelected(user: any) {
		user.isUserSelected = !user.isUserSelected;
	}

	setSelectedPos(pos: any) {
		pos.isPosSelected = !pos.isPosSelected;
	}

	reportDate(userId: number, ttip: any) {
		ttip.close();
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_USER_DEP;
		modalRef.componentInstance.userId = userId;
	}

	reportDateDep(userId: number) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_USER_DEP;
		modalRef.componentInstance.userId = userId;
	}

	changeActiveStatus(user: any, ttip: any) {
		ttip.close();
		let canModify = true;
		let pos = '';

		if (this.group.head || this.group.deputy) {
			if (this.group.head) {
				if (user.user.id === this.group.head.id) {
					pos = GROUP_CONSTANTS.HEAD_POSITION;
					canModify = false;
				}
			}
			if (this.group.deputy) {
				if (user.user.id === this.group.deputy.id) {
					pos = GROUP_CONSTANTS.DEPUTY_POSITION;
					canModify = false;
				}
			}
		}

		if (canModify) {
			this.showConfirmInactiveUserModal(user, pos);
		} else {
			this.changeHeadDeputyAlert(user, pos);
		}

		this.popoverIsHidden = true;
	}

	private showConfirmInactiveUserModal(user: any, pos: string) {
		const modalRef = this.modalService.open(ConfirmationPopupComponent);
		modalRef.componentInstance.massage = 'Change the status of user ' + user.user.firstName + ' ' + user.user.lastName + ' to inactive?';
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.adminService.changeUserStatusInGroup(this.group.id, user.user.id, GROUP_CONSTANTS.ACTIVE_STATUS).subscribe(
					(response) => {
						if (response.status === HTTP_STATUS_CODES.OK) {
							const index = this.group.activeUsers.indexOf(user);
							if (index > -1) {
								this.group.activeUsers.splice(index, 1);
								this.group.inactiveUsers.push(user);
							}
						}
					},
					(error) => {
						if (error.status === HTTP_STATUS_CODES.PRECONDITION_FAILED) {
							this.changeHeadDeputyAlert(user, pos);
						}
					});
			}
		});
	}

	changeHeadDeputyAlert(user, pos) {
		const modalRef = this.modalService.open(AlertShowComponent);
		modalRef.componentInstance.massage = user.user.firstName + ' ' + user.user.lastName + ' is currently a ' + pos + ' here. ' +
			'Please set a new ' + pos + ' first and then try again.';

	}

	popoverMouseEnter(flag) {
		this.popoverIsHidden = flag;
	}

	changeInactiveStatus(user: any) {
		const modalRef = this.modalService.open(ConfirmationPopupComponent);
		modalRef.componentInstance.massage = 'Change the status of user ' + user.user.firstName + ' ' + user.user.lastName + ' to active?';
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.adminService.changeUserStatusInGroup(this.group.id, user.user.id, GROUP_CONSTANTS.INACTIVE_STATUS).subscribe(
					(response) => {
						if (response.status === HTTP_STATUS_CODES.OK) {
							const index = this.group.inactiveUsers.indexOf(user);
							if (index > -1) {
								this.group.inactiveUsers.splice(index, 1);
								this.group.activeUsers.push(user);
							}
						}
					},
					() => {
					});
			}
		});
	}

	openAddMember() {
		const modalRef = this.modalService.open(AddMemberPopupComponent);
		modalRef.componentInstance.setGroup(this.group);
	}

	openSetHeadDeputy() {
		const modalRef = this.modalService.open(SetHeadDeputyComponent);
		modalRef.componentInstance.setGroup(this.group);
		modalRef.componentInstance.setShowHeadFields(this.isAdmin);
	}

	openChangePosition(user: any, ttip: any) {
		ttip.close();
		const modalRef = this.modalService.open(ChangeUserPositionComponent);
		modalRef.componentInstance.setGroup(this.group);
		modalRef.componentInstance.setUserPosData(user);
		modalRef.componentInstance.setPrevPos(user.position);
	}

	openReportDatepicker() {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_GROUP;
		modalRef.componentInstance.groupId = this.group;
		modalRef.componentInstance.groupName = this.group.name;
	}

	openReportDatepickerDep(groupId: number, groupName: string) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_GROUP;
		modalRef.componentInstance.groupId = groupId;
		modalRef.componentInstance.groupName = groupName;
	}

	openReportDatepickerVector() {
		this.dataListVector = [];
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VECTOR;
		modalRef.componentInstance.groupId = this.group.id;
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.dataListVector = JSON.parse(localStorage.getItem('dataList'));

				if (this.dataListVector.length === 0) {
					this.nodata = true;
					setTimeout(() => this.nodata = false, TIMEOUT_VALUES.LONG_DELAY);
				} else {
					this.suc = true;
					setTimeout(() => this.suc = false, TIMEOUT_VALUES.LONG_DELAY);
				}
			}
		});
	}

	openGroupLeaveModal() {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_DAY_OFF_GROUP;
		modalRef.componentInstance.groupId = this.group;
		modalRef.componentInstance.action(GROUP_CONSTANTS.TAKE_LEAVE_ON_GROUP);

		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.suc = true;
				setTimeout(() => this.suc = false, TIMEOUT_VALUES.DEFAULT_DELAY);
			}
		});
	}

	deleteUser(userId: number, index: number) {
		this.userService.deleteUserFromGroup(userId, this.group.id).subscribe(
			(standResponse: any) => {
				if (standResponse.status === HTTP_STATUS_CODES.OK) {
					document.location.reload();
				}
			},
			(error) => {
			}
		);
	}
}


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/view-group.component.ts